import * as React from "react";
import { action, observable } from "mobx";
import { observer } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { ILocalization } from "../../../models/localization";
import { ScreenMode } from "../../../models/enums";
import { Auth } from "../../../utils/auth";
import Button from "material-ui/Button";
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, withMobileDialog } from "material-ui/Dialog";
import Input, { InputLabel } from "material-ui/Input";
import TextField from "material-ui/TextField";
import { FormControl } from "material-ui/Form";
import { ValidatorForm } from "react-material-ui-form-validator";
import { TextValidator } from "react-material-ui-form-validator";

@observer
export default class PasswordResetDlg extends React.Component<{ store: SeekerStore }, {}> {
  @observable username: string;
  @observable success: boolean;
  @observable emailFlag: boolean;
  @observable submitMessage: string;

  constructor(props: any) {
    super(props);
    this.emailFlag = this.success = false;
    this.username = this.submitMessage = "";
  }

  @action closeDialog = (): void => {
    this.props.store.viewState.closePasswordReset();
    this.emailFlag = this.success = false;
    this.username = this.submitMessage = "";
  }

  @action handleInputChange = (target: any): void => {
    this[target.id] = target.value;
  }

  @action handleSubmit = (): void => {
    Auth.requestPassword(this.username, this.renderConfirmation);
  }

  @action renderConfirmation = (success: boolean): void => {
    if (success) {
      this.submitMessage = this.props.store.localization.fields.forgotPwdDlg.messageSuccess;
      this.success = true;
    } else {
      this.submitMessage = this.props.store.localization.fields.forgotPwdDlg.messageFail;
    }
    this.emailFlag = true;
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const submitted: boolean = false;
    const disabled: boolean = true;

    return (
      <Dialog
        open={this.props.store.viewState.showPasswordReset}
        onClose={() => this.closeDialog}
        aria-labelledby="responsive-dialog-title"
        fullScreen={mode === ScreenMode.Mobile} >
        <DialogTitle id="alert-dialog-title">{local.forgotPwdDlg.title}</DialogTitle>
        <ValidatorForm
          ref="form"
          instantValidate={false}
          onSubmit={this.handleSubmit}>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{local.forgotPwdDlg.content}</DialogContentText>
            <br />
            <TextValidator
              label={local.login.enterEmail}
              name="username"
              id="username"
              validators={['required', 'isEmail']}
              errorMessages={[local.validation.requiredField, local.validation.invalidEmail]}
              value={this.username}
              onChange={(e: any) => this.handleInputChange(e.target)} />
            <br /><h4>{this.emailFlag ? this.submitMessage : null}</h4><br />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.closeDialog()}
              color="secondary">
              {local.close}
            </Button>
            <Button
              type="submit"
              color="secondary"
              disabled={this.success}
              autoFocus>
              {local.forgotPwdDlg.reset}
            </Button>
          </DialogActions>
        </ValidatorForm>
      </Dialog>);
  }
}


// WEBPACK FOOTER //
// ./src/components/dialogs/passwordReset/index.tsx